var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61523e-05 18.0523C-0.0102836 14.4901 1.03659 11.0048 3.00814 8.03786C4.9797 5.0709 7.78728 2.75565 11.0754 1.38525C14.3636 0.0148402 17.9844 -0.349097 21.4795 0.339514C24.9746 1.02812 28.1868 2.73831 30.7094 5.25356C33.232 7.76881 34.9515 10.976 35.6503 14.4691C36.3491 17.9622 35.9957 21.584 34.6349 24.8761C33.274 28.1683 30.967 30.9826 28.0058 32.9628C25.0445 34.943 21.5624 36 18.0001 36C15.6397 36.0034 13.3018 35.5419 11.1198 34.6418C8.93779 33.7417 6.95444 32.4207 5.28299 30.7541C3.61153 29.0875 2.28471 27.108 1.37826 24.9286C0.471819 22.7493 0.00351082 20.4127 7.61523e-05 18.0523Z",
    fill: "#FCE1E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9231 6.19763L22.918 3.78906L6.0212 29.8016L10.0264 32.2101L26.9231 6.19763Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.25H12C11.1716 14.25 10.5 14.9216 10.5 15.75V23.25C10.5 24.0784 11.1716 24.75 12 24.75H24C24.8284 24.75 25.5 24.0784 25.5 23.25V15.75C25.5 14.9216 24.8284 14.25 24 14.25Z",
    stroke: "#EE4A62",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24.75V12.75C21 12.3522 20.842 11.9706 20.5607 11.6893C20.2794 11.408 19.8978 11.25 19.5 11.25H16.5C16.1022 11.25 15.7206 11.408 15.4393 11.6893C15.158 11.9706 15 12.3522 15 12.75V24.75",
    stroke: "#EE4A62",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.d8c396c4f33ce7e82d8319e8953adca8.svg";
export { ForwardRef as ReactComponent };